import React, { useMemo } from "react"
import { graphql, useStaticQuery } from 'gatsby'
import { FormattedHTMLMessage, injectIntl } from 'react-intl'
import { Link } from '../components/localizedlink'
import { mapLocalized } from '../utils'
// import { inlineLexer } from 'marked'
//import InfoIcon from '../images/svg-icons/info-circle-light.svg'


const Tickets = ({ intl: { locale }, hideIntro, landing }) => {
  const data = useStaticQuery(graphql`
    query {
      tickets: allTicketsYaml{
        edges{
          node{
            title
            price
            intro
            info
            activity
            dates
            date1
            date2
            ticket12
            ticket1
            ticket2
            lang
            discounts
            discount1 {
              title
              text
            }
            discount2 {
              title
              text
            }
          }
        }
      }
    }
  `);
  const { tickets: { title, price, /*intro, info,*/ activity, dates, date1, date2, ticket12, ticket1, ticket2, discounts, discount1 } } =
    useMemo(() => mapLocalized(data, locale), [data, locale]);

  return (
    <section id="tickets" className="section tickets" aria-labelledby="tickets" itemProp="offers" itemScope="itemscope" itemType="http://schema.org/Offer">
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
            {!hideIntro && (
              <div data-aos="fade-up">
                <h1 id="region-tickets" className={`section__title${landing? ' mt-5 text-center' : ''}`}>{title}</h1>
              </div>
            )}
            <div className="line-separator" data-aos="fade-up">
              {/*
              <div className="tickets__intro">
                  <InfoIcon/>
                  <div className="icon" dangerouslySetInnerHTML={{ __html: intro }}></div>
                </div>
              */}
              <div className="row">
                <div className="col-sm-3 d-none d-md-block">
                  <div className="tickets__info tickets__info--price">{price}</div>
                  {/* <div className="tickets__info tickets__info--early" dangerouslySetInnerHTML={{ __html: inlineLexer(info, []) }}></div> */}
                  <div className="tickets__info">{activity}</div>
                </div>
                <div className="col-md-9">
                  <div className="row text-center">
                    <div className="col-sm-4">
                      <div className="row">
                        <div className="col-12">
                          <div className="tickets__date">{dates}</div>
                          <div className="tickets__price tickets__price--sm">
                            <div className="d-block d-md-none">{price}</div>
                              € 1000
                          </div>
                          {/*
                          <div className="tickets__price tickets__price--early tickets__price--sm">
                            <div className="d-block d-md-none" dangerouslySetInnerHTML={{ __html: inlineLexer(info, []) }}></div>
                              € 750
                          </div>
                          */}
                          <div className="tickets__activity">
                            <div className="d-block d-md-none">{activity}</div>
                            {ticket12.map((item, i) => <p key={i}>{item}</p>)}
                          </div>
                          <Link to="/acquista/completaiscrizione/" title="acquista" className="btn-cta btn-style-2" state={{ ticketId: 2 }}>
                            <FormattedHTMLMessage id="acquista-14-15" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="row">
                        <div className="col-6">
                          <div className="tickets__date">{date1}</div>
                          <div className="tickets__price">
                            <div className="d-block d-md-none">{price}</div>
                              € 500
                          </div>
                          {/*
                          <div className="tickets__price tickets__price--early">
                            <div className="d-block d-md-none" dangerouslySetInnerHTML={{ __html: inlineLexer(info, []) }}></div>
                              € 375
                          </div>
                          */}
                          <div className="tickets__activity">
                            <div className="d-block d-md-none">{activity}</div>
                            {ticket1.map((item, i) => <p key={i}>{item}</p>)}
                          </div>
                          <Link to="/acquista/completaiscrizione/" title="acquista" className="btn-cta btn-style-2" state={{ ticketId: 0 }}>
                            <FormattedHTMLMessage id="acquista-14" />
                          </Link>
                        </div>
                        <div className="col-6">
                          <div className="tickets__date">{date2}</div>
                          <div className="tickets__price">
                            <div className="d-block d-md-none">{price}</div>
                              € 500
                          </div>
                          {/*
                          <div className="tickets__price tickets__price--early">
                            <div className="d-block d-md-none" dangerouslySetInnerHTML={{ __html: inlineLexer(info, []) }}></div>
                              € 375
                          </div>
                          */}
                          <div className="tickets__activity">
                            <div className="d-block d-md-none">{activity}</div>
                            {ticket2.map((item, i) => <p key={i}>{item}</p>)}
                          </div>
                          <Link to="/acquista/completaiscrizione/" title="acquista" className="btn-cta btn-style-2" state={{ ticketId: 1 }}>
                            <FormattedHTMLMessage id="acquista-15" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            
            <div className="tickets__discounts" data-aos="fade-up">
                <div className="row">
                  <div className="col-md-2">
                    <div className="tickets__info tickets__info--discount">{discounts}</div>
                  </div>
                  <div className="col-md-10">
                    <div className="row">
                      <div className="col-sm-6 col-md-4 offset-md-1">
                        <div className="">
                          <div dangerouslySetInnerHTML={{ __html: discount1.title }}></div>
                          <p dangerouslySetInnerHTML={{ __html: discount1.text }}></p>
                        </div>
                      </div>
                      {/* <div className="col-sm-6 col-md-4 offset-md-1">
                        <div className="">
                          <div dangerouslySetInnerHTML={{ __html: discount2.title }}></div>
                          <p dangerouslySetInnerHTML={{ __html: discount2.text }}></p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
             

          </div>
        </div>
      </div>
    </section >
  );
}

export default injectIntl(Tickets);